import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService, EncryptService } from '../core/services';

@Injectable({
  providedIn: 'root',
})
export class SessionGuard implements CanActivate {
  constructor(
    private readonly encrypt: EncryptService,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.validateSession()) {
      return true;
    } else {
      this.authService.logout();
      return this.router.createUrlTree(['/']);
    }
  }

  private validateSession(): boolean {
    let session = false;
    if (
      this.encrypt.getSession() !== '' &&
      typeof this.encrypt.getSession().idUsuario === 'number'
    ) {
      session = true;
    }
    var diff = Math.abs(
      new Date(this.encrypt.getSession().FechaInicio).getTime() -
        new Date().getTime()
    );
    var minutes = Math.floor(diff / 1000 / 60 / 60);
    if (minutes > 23) {
      session = false;
    }
    return session;
  }
}
